import React from 'react';
import { Box } from '@mui/material';
import type { CampaignDto } from '@shared/services/apiService/apiService';
import CallAnalysisGeneral from './analysis/CallAnalysisGeneral';

interface CallAnalysisTabProps {
  campaign: CampaignDto;
}

const CallAnalysisTab: React.FC<CallAnalysisTabProps> = ({ campaign }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <CallAnalysisGeneral campaignId={campaign.id} isSquadCampaign={Boolean(campaign.squad)} />
    </Box>
  );
};

export default CallAnalysisTab;
